import { CUSTOMER_LIST_HIDDEN_TYPES } from '@catalyst-psa/shared';

import { CustomerListView } from './CustomerListView.js';

export function CustomersPage(): JSX.Element {
  return (
    <CustomerListView
      title="Customers"
      description="Manage the companies you bill and deliver work for."
      scope="customers"
      hiddenTypeNames={CUSTOMER_LIST_HIDDEN_TYPES}
      createLabel="New customer"
      basePath="/customers"
    />
  );
}
